import {Route, Routes} from "react-router-dom";
import HomePage from "./HomePage";
import InvitesPage from './InvitesPage';
import WaitingPage from './WaitingPage';
import BlackListPage from './BlackListPage';
import ClientsPage from './ClientsPage';
import StatsPage from './StatsPage';
import SideNavbar from "./SideNavbar";
import MainFooter from "./MainFooter";
import Loading from "../comps/Loading";
import {useState, useEffect} from "react";
import manageareas from "../services/manageareas";
import TablePage from "./TablePage";
import Test from './Test.js'
import TopNavbar from "./TopNavbar";
import LivePage from "./LivePage";
import managecookies from "../services/managecookies";

function MainPage() {
    const [isLoading, setLoading] = useState(true);
    const [areaLocked,setAreaLock] = useState(0)
    const [isWorker, setIsWorker] = useState(false);

    useEffect(()=>{
        const data = JSON.parse(managecookies.getCookieVal('userData'));
        setIsWorker(data.business.length >= 1);
    })

    const handleAreaListReq = async () => {
        try {
            let areaList = await manageareas.getAllArea(handleFailAreaList)
            if (areaList) setLoading(false)
        } catch (error) {
            console.error('Error fetching areas:', error);
        }
    };

    const handleFailAreaList = () => {
        setLoading(false);
    };

    useEffect(() => {
        handleAreaListReq();
    }, []);

    return (
        isLoading ? (
            <Loading />
        ) : (
            isWorker ? (
                <>
                    <div className="main-page-container">
                        <div>
                            <SideNavbar />
                        </div>
                        <div className="main-page-left">
                            <TopNavbar setAreaLock={setAreaLock} isWorker={isWorker} />
                            <Routes>
                                <Route path="/" element={<HomePage />} />
                                <Route path="/live" element={<Test />} />
                                <Route path="/invite" element={<InvitesPage />} />
                                <Route path="/wait" element={<WaitingPage />} />
                                <Route path="/blacklist" element={<BlackListPage />} />
                                <Route path="/clients" element={<ClientsPage />} />
                                <Route path="/stats" element={<StatsPage />} />
                            </Routes>
                        </div>
                    </div>
                    <MainFooter />
                </>
            ) : (
                <div className="text-center p-10 text-lg text-gray-700">
                    <TopNavbar setAreaLock={setAreaLock} />
                    <div>אין הרשאות </div>
                </div>
            )
        )
    );
}

export default MainPage;
